
import React, {useState} from 'react';
import ActionItemInformationPage1 from './ActionItemInformationPage1.mjs';
import ActionItemInformationPage2 from './ActionItemInformationPage2.mjs';
import './ActionItemInformation.css';

export default function ActionItemInformation() 
{
    const [page_num, setPageNum] = useState(1); 
    const [page, setPage] = useState( <> <ActionItemInformationPage1 /> </> );

    const show_page = (num) => { 

        if (page_num == num)
            return;

        switch (num)
        {
            case 1:
            default:
                setPage( <> <ActionItemInformationPage1 /> </> ); 
                break;
            case 2:
                setPage( <> <ActionItemInformationPage2 /> </> ); 
                break;
        }

        setPageNum(num);
    }

    return ( 
        <> 
            <div class="alert alert-light mt-2" role="alert">
                <nav className="py-0" aria-label="...">
                    <ul class="pagination pagination-sm justify-content-center">
                        <li class="page-item" onClick={ () => show_page(1) } aria-current="page">
                            <span class="page-link">intro</span>
                        </li>
                        <li class="page-item" onClick={ () => show_page(2) }><a class="page-link" href="#">icons</a></li>
                    </ul>
                </nav>
                <div className="action-item-info"><small>{page}</small></div>
            </div>
        </> 
    );
}


/*
                <small>
                    <ActionItemInformationPage1 />
                </small>

*/